import { Nullable, PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { TextBox } from "./TextBox";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorTextBoxPropertyValues =
    PropertyEditorPropertyValues
    & {
        autoComplete: string;
        placeholder: string;
    };

export type PropertyEditorTextBoxProperties = {
    [name in keyof PropertyEditorTextBoxPropertyValues]: Property<PropertyEditorTextBoxPropertyValues[name]>
};

export interface IPropertyEditorTextBox extends IPropertyEditor, PropertyEditorTextBoxProperties
{
}

export class PropertyEditorTextBox extends PropertyEditor implements IPropertyEditorTextBox
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorTextBox";
    public static override className = "PropertyEditorTextBox";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorTextBoxPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                autoComplete: "off",
                createEditorControl: () => new TextBox(),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public autoComplete!: PropertyString;
    public placeholder!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyEditorTextBoxPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-property-editor-text-box");

        // Trigger Property Changes
        this.autoComplete.triggerChange();
        this.placeholder.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _autoCompleteChanged(change: PropertyChange<string>)
    {
        const
            editorControl = this.editorControl.get() as Nullable<TextBox>;

        if (!editorControl || !editorControl.autoComplete.set)
            return;

        editorControl.autoComplete.set(change.currentValue);
    }
    protected _placeholderChanged(change: PropertyChange<string>)
    {
        const
            editorControl = this.editorControl.get() as Nullable<TextBox>;

        if (!editorControl || !editorControl.placeholder.set)
            return;

        editorControl.placeholder.set(change.currentValue);
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: PropertyEditorTextBoxPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.autoComplete = new PropertyString(this, propertyValues.autoComplete, this._autoCompleteChanged);
        this.placeholder = new PropertyString(this, propertyValues.placeholder, this._placeholderChanged);
    }

    // #endregion

    // #endregion
}
